<template>
  <div>
    <v-row>
      <v-col>
        <v-card class="rounded-lg">
          <v-card-text>
            <h3> Logistica y Almacén </h3>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <InternalMenuLogistic />
  </div>
</template>

<script>
import InternalMenuLogistic from "@/components/logistic/InternalMenuLogistic.vue";

export default {
  components: {
    InternalMenuLogistic,
  },
};
</script>
<style scoped>
.app-container {
  display: flex;
  height: 100vh; /* Esto hace que el componente ocupe todo el espacio vertical */
}
</style>